import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "../redux/blockchain/blockchainActions";
import { fetchData } from "../redux/data/dataActions";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import logo from "../Assets/rp.png";
// import { connectWallet, getCurrentWalletConnected } from "../utils/interact";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import {
  AiOutlineHome,
  AiOutlineUser,
} from "react-icons/ai";
import { BiLinkExternal } from "react-icons/bi";

function NavBar() {

  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const [walletAddress, setWallet] = useState("");
 
  useEffect( () => { 
    async function getWallet() {
      dispatch(connect());
    if(blockchain.account !== null){
          setWallet(blockchain.account);
        }
    }
    getWallet();
  }, []);

  useEffect(() => {
    if(blockchain.account !== null){
          setWallet(blockchain.account);
    }
  }, [blockchain.account]);


  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
       <Container>
        <Navbar.Brand href="/">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto" defaultActiveKey="#home">
            <Button variant="primary" href="https://rugpullprevention.com" target="_blank">
              <BiLinkExternal /> &nbsp;
              {"Rugpull Prevention"}
            </Button>

            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>
                 Home
              </Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
              <Nav.Link as={Link} to="/detectivescores" onClick={() => updateExpanded(false)}>
                 Detective Scores
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/cryptograveyard" onClick={() => updateExpanded(false)}>
                 Crypto Graveyard
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/roadmap" onClick={() => updateExpanded(false)}>
                 Roadmap
              </Nav.Link>
            </Nav.Item> */}
            {/* <NavDropdown title="DAPPS" className="nav-dropdown-menu">
              <NavDropdown.Item className="nav-dropdown" as={Link} to="/staking" onClick={() => updateExpanded(false)}>DAO Staking</NavDropdown.Item>
              <NavDropdown.Item className="nav-dropdown"  as={Link} to="/mintnft" onClick={() => updateExpanded(false)}>NFT Store</NavDropdown.Item>
              <NavDropdown.Divider  className="nav-dropdown"/>
              <NavDropdown.Item className="nav-dropdown"  as={Link} to="/nftgallery" onClick={() => updateExpanded(false)}>NFT Gallery</NavDropdown.Item>
            </NavDropdown> */}
            <Nav.Item>
              <Nav.Link as={Link} to="/staking" onClick={() => updateExpanded(false)}>
                 DG Staking
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/mintnft" onClick={() => updateExpanded(false)}>
                 NFT Store
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/nftgallery" onClick={() => updateExpanded(false)}>
                 NFT Gallery
              </Nav.Link>
            </Nav.Item>
            <Button variant="warning" id="walletButton" 
              onClick={(e) => {
                e.preventDefault();
                dispatch(connect());
//                getData();
              }}>
              {walletAddress.length > 0 ? (
                "Connected: " +
                String(walletAddress).substring(0, 6) +
                "..." +
                String(walletAddress).substring(38)
              ) : (
                <span>Connect Wallet</span>
              )}
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>  );
}

export default NavBar;
